import { ChevronDirection, ChevronIcon } from '../../../components/Icon';

interface ApprovalDetailsNavigationProps {
  canGoNext: boolean;
  canGoPrevious: boolean;
  className?: string;
  onNext: () => void;
  onPrevious: () => void;
}

function ApprovalDetailsNavigation({
  canGoNext,
  canGoPrevious,
  className = '',
  onNext,
  onPrevious,
}: ApprovalDetailsNavigationProps) {
  return (
    <nav
      aria-label='Approval navigation'
      className={`approval-details-navigation ${className}`.trim()}
      data-testid='approval-details-navigation'>
      <button
        aria-label='Previous approval'
        className='approval-details-navigation__link'
        data-testid='approval-details-navigation-previous'
        disabled={!canGoPrevious}
        type='button'
        onClick={onPrevious}>
        <ChevronIcon
          className='approval-details-navigation__chevron'
          direction={ChevronDirection.LEFT}
          size={16}
        />
        <span>Previous</span>
      </button>
      <button
        aria-label='Next approval'
        className='approval-details-navigation__link'
        data-testid='approval-details-navigation-next'
        disabled={!canGoNext}
        type='button'
        onClick={onNext}>
        <span>Next</span>
        <ChevronIcon
          className='approval-details-navigation__chevron'
          direction={ChevronDirection.RIGHT}
          size={16}
        />
      </button>
    </nav>
  );
}

export default ApprovalDetailsNavigation;
